import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
})
export class FilterByPipe implements PipeTransform {
  transform<T>(
    arr: T[] | undefined,
    predicate: (value: T, index: number, array: T[]) => boolean
  ): T[] {
    if (arr) return arr.filter(predicate);
    return [];
  }
}
